import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ListItem } from '../list-item/list-item'

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectComponent {

  selectedValue: string
  selectedItemIndex = 0
  itemsVal: ListItem[]
  @Input() text: string
  @Input() cssClass: string
  @Output() onSelect = new EventEmitter<ListItem>()

  @Input()
  set itemIndex(val: number) {
    this.selectedItemIndex = val
    this.updateSelectedValue()
  }

  @Input() set items(val: ListItem[]) {
    this.itemsVal = val
    this.updateSelectedValue()
  }

  onChange(val: string) {
    this.onSelect.emit(this.itemsVal.find(i => i.value === val))
  }

  private updateSelectedValue() {
    if (typeof this.selectedItemIndex === 'number' && this.itemsVal && this.itemsVal.length > 0) {
      this.selectedValue = this.itemsVal[this.selectedItemIndex].value
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/select/select.component.ts